import { fetchList } from '@/api/setting/brand'
import { dataToOpts } from '@/utils/opts'
import _ from 'lodash'

const query = {
  limit: 100,
  sort: 'id'
}

const brand = {
  state: {
    list: [],
    data: {},
    inited: false
  },

  mutations: {
    INIT_BRAND: (state, data) => {
      state.inited = true
      state.data = dataToOpts(data)
      state.list = _.cloneDeep(state.data.opts)
    }
  },

  actions: {
    InitBrand ({ commit }) {
      if (this.state.brand.inited) {
        return new Promise((resolve) => {
          resolve(this.state.brand.data)
        })
      }
      return new Promise((resolve, reject) => {
        fetchList(query).then(res => {
          commit('INIT_BRAND', res.data)
          resolve(this.state.brand.data)
        }).catch(() => {
          // do nothing
        })
      })
    },
    ResetBrand ({ commit }) {
      // do nothing when no translation needed
    }
  }
}

export default brand
